import React, { useEffect } from 'react';
import {
  apiCallBegan,
  APICallMethods
} from '@gjensidige/se-redux-api-middleware';
import { DocumentLinks } from '@gjensidige/se-document-links';
import { useAppDispatch, useAppSelector } from '../hooks/appHooks';
import { API_ENDPOINTS } from '../lib/constants';
import { API_OPERATIONS } from '../lib/constants/appConstants';
import { SESSION_KEYS } from '../lib/constants/appConstants';
import { onApiSuccess } from '../store/slices/offerSlice';
import { AppConstants } from '../utils/AppConstants';
import { TrackingHelper } from '../utils/TrackingHelper';
import tracker from '../tracking';

export const InsuranceDocumentsContainer = ({ displayAsExpandable }: { displayAsExpandable?: boolean }) => {
  const dispatch = useAppDispatch();
  const offerInfo = useAppSelector((state) => state.insurance.offer);
  const productDocumentsInfo = useAppSelector(
    (state) => state.insurance.productDocuments
  );
  const contractCode = offerInfo.contractCode
    ? Number(offerInfo.contractCode)
    : 0;
  const productCode = offerInfo.productCode ? Number(offerInfo.productCode) : 0;
  useEffect(() => {
    if (!productDocumentsInfo?.productCode) {
      dispatch(
        apiCallBegan({
          init: '',
          url:
            API_ENDPOINTS.getProductDocumentsUrl +
            productCode +
            '/contract-code/' +
            contractCode +
            '/current-document',
          // url: "https://www.testgjensidige.se/product-documents/documents/product-code/1001/contract-code/100/current",
          apiOperation: API_OPERATIONS.GET_PRODUCT_DOCUMENTS,
          method: APICallMethods.GET_JSON,
          onStart: '',
          onSuccess: onApiSuccess.type,
          onError: ''
        })
      );
    }
  }, []);

  const getTracker = () => {
    tracker.options.scenario_step = 'choose-plan'
    tracker.options.scenario_name = TrackingHelper.getScenarioNameFromProduct(offerInfo.productName)
    return tracker;
  }

  return (
    <>
      {productDocumentsInfo?.productCode && (
        <DocumentLinks
          ipidTitle={AppConstants.getAppText('webshop.documents.ipidLinkText')}
          linkTitle={AppConstants.getAppText('webshop.insuranceDocument.title')}
          prepurchaseInfoTitle={AppConstants.getAppText(
            'webshop.documents.purchaseInfoLinkText'
          )}
          termsAndConditionsTitle={AppConstants.getAppText(
            'webshop.documents.termsAndConditionLinkText'
          )}
          productDocuments={
            productDocumentsInfo ? productDocumentsInfo : (null as any)
          }
          openInNewWindow={true}
          trackingObject={
            getTracker()
          }
          displayAsExpandable={displayAsExpandable}
        />
      )}
    </>
  );
};
